/** @jsxImportSource @emotion/react */
import type { ApiScanVideoSubmission } from '@kaiizen/kai-pro-api';

import type { VideoToolboxClipReadStatus } from '../VideoToolbox/videoToolboxClipReadStatusLib';
import type { FocusedMediaStripVideoEntry } from './focusedMediaStripLib';
import { FocusedStrip } from './focusedStrip/FocusedStrip';
import type { FocusedStripStyles } from './focusedStrip/focusedStripStyles';
import { DEFAULT_FOCUSED_STRIP_STYLES } from './focusedStrip/focusedStripStyles';
import type { FocusedPhotoStripEntry } from './focusedStrip/focusedStripTypes';

export type FocusedMediaStripProps = {
  photos: readonly FocusedPhotoStripEntry[];
  videos: readonly FocusedMediaStripVideoEntry[];
  submissionsByVideoId: Record<string, ApiScanVideoSubmission>;
  emptyLabel: string;
  title?: string;
  actionLabel?: string;
  showTaskChipLabels?: boolean;
  styles?: FocusedStripStyles;
  onAction?: () => void;
  onOpenPhotoManager?: () => void;
  onSelectPhoto: (photo: FocusedPhotoStripEntry) => void;
  onSelectVideo: (video: FocusedMediaStripVideoEntry, submission?: ApiScanVideoSubmission) => void;
  resolveVideoClipReadStatus: (video: FocusedMediaStripVideoEntry) => VideoToolboxClipReadStatus;
};

/** Walkthrough videos lead photos in the scope editor media strip. */
export const FocusedMediaStrip = ({
  photos,
  videos,
  submissionsByVideoId,
  emptyLabel,
  title,
  actionLabel,
  showTaskChipLabels,
  styles = DEFAULT_FOCUSED_STRIP_STYLES,
  onAction,
  onOpenPhotoManager,
  onSelectPhoto,
  onSelectVideo,
  resolveVideoClipReadStatus,
}: FocusedMediaStripProps) => (
  <FocusedStrip
    photos={photos}
    videos={videos}
    submissionsByVideoId={submissionsByVideoId}
    emptyLabel={emptyLabel}
    title={title}
    actionLabel={actionLabel}
    showTaskChipLabels={showTaskChipLabels}
    styles={styles}
    countMode={'media'}
    testId={'focused-media-strip'}
    onAction={onAction}
    onOpenPhotoManager={onOpenPhotoManager}
    onSelectPhoto={onSelectPhoto}
    onSelectVideo={onSelectVideo}
    resolveVideoClipReadStatus={resolveVideoClipReadStatus}
  />
);

export type { FocusedMediaStripVideoEntry } from './focusedMediaStripLib';
export { DEFAULT_FOCUSED_STRIP_STYLES, type FocusedStripStyles } from './focusedStrip/focusedStripStyles';
